import { Link } from 'react-router-dom'
export default function Policy() {
  return (
    <div className="legal-page fade-in">
      <div className="container">
        <div className="legal-card neon-border">
          <div className="header">
            <Link to="/"> <img src="public/clabs_logo.png" alt="CLabs Logo" className="logo" /> </Link>
            <h1>Privacy Policy</h1>
            <span className="date">Last updated January 8th 2026</span>
          </div>

          <div className="content">
            <h3>PRIVACY POLICY</h3>
            <p>Last updated January 8th 2026</p>
            
            <p>This privacy notice for Consilient Labs Inc ("we," "us," or "our"), describes how and why we might</p>
            <p>collect, store, use, and/or share ("process") your information when you use our</p>
            <p>services ("Services"), such as when you:</p>
            <p>Visit our website at htps://www.consilientlabs.io, or any website of ours that links to</p>
            <p>this privacy notice.</p>
            <p>Engage with us in other related ways, including any sales, marketing, or events</p>
            <p>Questions or concerns? Reading this privacy notice will help you understand your</p>
            <p>privacy rights and choices. If you do not agree with our policies and practices, please</p>
            <p>do not use our Services. If you still have any questions or concerns, please contact</p>
            <p>us at contact@consilientlabs.io.</p>
            
            <h3>SUMMARY OF KEY POINTS</h3>
            <p>This summary provides key points from our privacy notice, but you can find</p>
            <p>out more details about any of these topics by clicking the link following each</p>
            <p>key point or by using our table of contents below to find the section you are</p>
            <p>looking for.</p>
            <p>What personal information do we process? When you visit, use, or navigate our</p>
            <p>Services, we may process personal information depending on how you interact with</p>
            <p>us and the Services, the choices you make, and the products and features you use.</p>
            <p>Learn more about personal information you disclose to us.</p>
            <p>Do we process any sensitive personal information? We do not process sensitive</p>
            <p>personal information.</p>
            <p>Do we collect any information from third parties? We do not collect any</p>
            <p>information from third parties.</p>
            <p>How do we process your information? We process your information to provide,</p>
            <p>improve, and administer our Services, communicate with you, for security and fraud</p>
            <p>prevention, and to comply with law. We may also process your information for other</p>
            <p>purposes with your consent. We process your information only when we have a valid</p>
            <p>legal reason to do so. Learn more about how we process your information.</p>
            <p>In what situations and with which parties do we share personal information?</p>
            <p>We may share information in specific situations and with specific third parties. Learn</p>
            <p>more about when and with whom we share your personal information.</p>
            <p>What are your rights? Depending on where you are located geographically, the</p>
            <p>applicable privacy law may mean you have certain rights regarding your personal</p>
            <p>information. Learn more about your privacy rights.</p>
            <p>How do you exercise your rights? The easiest way to exercise your rights is by</p>
            <p>visiting htps://www.consilientlabs.io, or by contacting us. We will consider and act upon any</p>
            <p>request in accordance with applicable data protection laws.</p>
            <p>Want to learn more about what we do with any information we collect? Review the</p>
            <p>privacy notice in full.</p>

            <h3>1. WHAT INFORMATION DO WE COLLECT?</h3>
            <p>Personal information you disclose to us</p>
            <p>In Short: We collect personal information that you provide to us.</p>
            <p>We collect personal information that you voluntarily provide to us when you register</p>
            <p>on the Services, express an interest in obtaining information about us or our products</p>
            <p>and Services, when you participate in activities on the Services, or otherwise when</p>
            <p>you contact us.</p>
            <p>Personal Information Provided by You. The personal information that we collect</p>
            <p>depends on the context of your interactions with us and the Services, the choices you</p>
            <p>make, and the products and features you use. The personal information we collect</p>
            <p>may include the following:</p>
            <p>names</p>
            <p>email addresses</p>
            <p>usernames</p>
            <p>passwords</p>
            <p>Sensitive Information. We do not process sensitive information.</p>
            <p>All personal information that you provide to us must be true, complete, and accurate,</p>
            <p>and you must notify us of any changes to such personal information.</p>
            <p>Information automatically collected</p>
            <p>In Short: Some information such as your Internet Protocol (IP) address and/or</p>
            <p>browser and device characteristics is collected automatically when you visit our</p>
            <p>Services.</p>
            <p>We automatically collect certain information when you visit, use, or navigate the</p>
            <p>Services. This information does not reveal your specific identity (like your name or</p>
            <p>contact information) but may include device and usage information, such as your IP</p>
            <p>address, browser and device characteristics, operating system, language</p>
            <p>preferences, referring URLs, device name, country, location, information about how</p>
            <p>and when you use our Services, and other technical information. This information is</p>
            <p>primarily needed to maintain the security and operation of our Services, and for our</p>
            <p>internal analytics and reporting purposes.</p>
            <p>Like many businesses, we also collect information through cookies and similar</p>
            <p>technologies. You can find out more about this in our Cookie Notice:</p>
            <p>htps://consilientlabs.io</p>
            <p>The information we collect includes:</p>
            <p>Log and Usage Data. Log and usage data is service-related, diagnostic,</p>
            <p>usage, and performance information our servers automatically collect when</p>
            <p>you access or use our Services and which we record in log files. Depending on</p>
            <p>how you interact with us, this log data may include your IP address, device</p>
            <p>information, browser type, and settings and information about your activity in</p>
            <p>the Services (such as the date/time stamps associated with your usage, pages</p>
            <p>and files viewed, searches, and other actions you take such as which features</p>
            <p>you use), device event information (such as system activity, error reports</p>
            <p>(sometimes called "crash dumps"), and hardware settings).</p>
            <p>Location Data. We collect location data such as information about your</p>
            <p>device's location, which can be either precise or imprecise. How much</p>
            <p>information we collect depends on the type and settings of the device you use</p>
                        <p>to access the Services. For example, we may use GPS and other technologies</p>
            <p>to collect geolocation data that tells us your current location (based on your IP</p>
            <p>address). You can opt out of allowing us to collect this information either by</p>
            <p>refusing access to the information or by disabling your Location setting on your</p>
            <p>device. However, if you choose to opt out, you may not be able to use certain</p>
            <p>aspects of the Services.</p>
            <p>User queries. User queries</p>
            <p>Query results. Query results</p>

            <h3>2. HOW DO WE PROCESS YOUR INFORMATION?</h3>
            <p>In Short: We process your information to provide, improve, and administer our</p>
            <p>Services, communicate with you, for security and fraud prevention, and to comply</p>
            <p>with law. We may also process your information for other purposes with your consent.</p>
            <p>We process your personal information for a variety of reasons, depending on</p>
            <p>how you interact with our Services, including:</p>
            <p>To facilitate account creation and authentication and otherwise manage</p>
            <p>user accounts. We may process your information so you can create and log</p>
            <p>in to your account, as well as keep your account in working order.</p>
            <p>To deliver and facilitate delivery of services to the user. We may process</p>
            <p>your information to provide you with the requested service.</p>
            <p>To respond to user inquiries/offer support to users. We may process your</p>
            <p>information to respond to your inquiries and solve any potential issues you might</p>
            <p>have with the requested service.</p>
            <p>To send administrative information to you. We may process your</p>
            <p>information to send you details about our products and services, changes to</p>
            <p>our terms and policies, and other similar information.</p>
            <p>To request feedback. We may process your information when necessary to</p>
            <p>request feedback and to contact you about your use of our Services.</p>
            <p>To send you marketing and promotional communications. We may</p>
            <p>process the personal information you send to us for our marketing purposes, if</p>
            <p>this is in accordance with your marketing preferences. You can opt out of our</p>
            <p>marketing emails at any time. For more information, see "WHAT ARE YOUR</p>
            <p>PRIVACY RIGHTS?" below.</p>
            <p>To protect our Services. We may process your information as part of our</p>
            <p>efforts to keep our Services safe and secure, including fraud monitoring and</p>
            <p>prevention.</p>
            <p>To identify usage trends. We may process information about how you use</p>
            <p>our Services to better understand how they are being used so we can improve</p>
            <p>them.</p>
            <p>To determine the effectiveness of our marketing and promotional</p>
            <p>campaigns. We may process your information to better understand how to</p>
            <p>provide marketing and promotional campaigns that are most relevant to you.</p>
            <p>To save or protect an individual's vital interest. We may process your</p>
            <p>information when necessary to save or protect an individuals vital interest,</p>
            <p>such as to prevent harm.</p>
            <p>Logs. Logs</p>
            <p>Logs and telemetry. Logs and telemetry</p>

            <h3>3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS</h3>
            <h3>YOUR INFORMATION?</h3>
            <p>In Short: We only process your personal information when we believe it is necessary</p>
            <p>and we have a valid legal reason (i.e., legal basis) to do so under applicable law, like</p>
            <p>with your consent, to comply with laws, to provide you with services to enter into or</p>
            <p>fulfill our contractual obligations, to protect your rights, or to fulfill our legitimate</p>
            <p>business interests.</p>
            <p>If you are located in the EU or UK, this section applies to you.</p>
            <p>The General Data Protection Regulation (GDPR) and UK GDPR require us to explain</p>
            <p>the valid legal bases we rely on in order to process your personal information. As</p>
            <p>such, we may rely on the following legal bases to process your personal information:</p>
            <p>Consent. We may process your information if you have given us permission</p>
            <p>(i.e., consent) to use your personal information for a specific purpose. You can</p>
            <p>withdraw your consent at any time. Learn more about withdrawing your</p>
            <p>consent.</p>
            <p>Performance of a Contract. We may process your personal information when</p>
            <p>we believe it is necessary to fulfill our contractual obligations to you, including</p>
            <p>providing our Services or at your request prior to entering into a contract with</p>
            <p>you.</p>
            <p>Legitimate Interests. We may process your information when we believe it is</p>
            <p>reasonably necessary to achieve our legitimate business interests and those</p>
            <p>interests do not outweigh your interests and fundamental rights and freedoms.</p>
            <p>For example, we may process your personal information for some of the</p>
            <p>purposes described in order to:</p>
            <p>Send users information about special offers and discounts on our products and services</p>
            <p>Analyze how our Services are used so we can improve them to engage</p>
            <p>and retain users</p>
            <p>Support our marketing activities</p>
            <p>Diagnose problems and/or prevent fraudulent activities</p>
            <p>Understand how our users use our products and services so we can</p>
            <p>improve user experience</p>
            <p>System stability</p>
            <p>Legal Obligations. We may process your information where we believe it is</p>
            <p>necessary for compliance with our legal obligations, such as to cooperate with</p>
            <p>a law enforcement body or regulatory agency, exercise or defend our legal</p>
            <p>rights, or disclose your information as evidence in litigation in which we are</p>
            <p>involved.</p>
            <p>Vital Interests. We may process your information where we believe it is</p>
            <p>necessary to protect your vital interests or the vital interests of a third party,</p>
            <p>such as situations involving potential threats to the safety of any person.</p>
            <p>In legal terms, we are generally the "data controller" under European data protection</p>
            <p>laws of the personal information described in this privacy notice, since we determine</p>
            <p>the means and/or purposes of the data processing we perform. This privacy notice</p>
            <p>does not apply to the personal information we process as a "data processor" on</p>
            <p>behalf of our customers. In those situations, the customer that we provide services to</p>
            <p>and with whom we have entered into a data processing agreement is the "data</p>
            <p>controller" responsible for your personal information, and we merely process your</p>
            <p>information on their behalf in accordance with your instructions. If you want to know</p>
            <p>more about our customers' privacy practices, you should read their privacy policies</p>
            <p>and direct any questions you have to them.</p>
            <p>If you are located in Canada, this section applies to you.</p>
            <p>We may process your information if you have given us specific permission (i.e.,</p>
            <p>express consent) to use your personal information for a specific purpose, or in</p>
            <p>situations where your permission can be inferred (i.e., implied consent). You</p>
            <p>can withdraw your consent at any time.</p>
            <p>In some exceptional cases, we may be legally permitted under applicable law to</p>
            <p>process your information without your consent, including, for example:</p>
            <p>If collection is clearly in the interests of an individual and consent cannot be</p>
            <p>obtained in a timely way</p>
            <p>For investigations and fraud detection and prevention</p>
            <p>For business transactions provided certain conditions are met</p>
            <p>If it is contained in a witness statement and the collection is necessary to</p>
            <p>assess, process, or settle an insurance claim</p>
            <p>For identifying injured, ill, or deceased persons and communicating with next</p>
            <p>of kin</p>
            <p>If we have reasonable grounds to believe an individual has been, is, or may be</p>
            <p>victim of financial abuse</p>
            <p>If it is reasonable to expect collection and use with consent would compromise</p>
            <p>the availability or the accuracy of the information and the collection is</p>
            <p>reasonable for purposes related to investigating a breach of an agreement or a</p>
            <p>contravention of the laws of Canada or a province</p>
            <p>If disclosure is required to comply with a subpoena, warrant, court order, or</p>
            <p>rules of the court relating to the production of records</p>
            <p>If it was produced by an individual in the course of their employment, business</p>
            <p>or profession and the collection is consistent with the purposes for which the</p>
            <p>information was produced</p>
            <p>If the collection is solely for journalistic, artistic, or literary purposes</p>
            <p>If the information is publicly available and is specified by the regulations</p>
            
            <h3>4. WHEN AND WITH WHOM DO WE SHARE YOUR</h3>
            <h3>PERSONAL INFORMATION?</h3>
            <p>In Short: We may share information in specific situations described in this section</p>
            <p>and/or with the following third parties.</p>
            <p>We may need to share your personal information in the following situations:</p>
            <p>Business Transfers. We may share or transfer your information in connection</p>
            <p>with, or during negotiations of, any merger, sale of company assets, financing,</p>
            <p>or acquisition of all or a portion of our business to another company.</p>
            <p>Affiliates. We may share your information with our affiliates, in which case we</p>
            <p>will require those affiliates to honor this privacy notice. Affiliates include our</p>
            <p>parent company and any subsidiaries, joint venture partners, or other</p>
            <p>companies that we control or that are under common control with us.</p>
            <p>Business Partners. We may share your information with our business</p>
            <p>partners to offer you certain products, services, or promotions.</p>
            
            <h3>5. DO WE USE COOKIES AND OTHER TRACKING</h3>
            <h3>TECHNOLOGIES?</h3>
            <p>In Short: We may use cookies and other tracking technologies to collect and store</p>
            <p>your information.</p>
            <p>We may use cookies and similar tracking technologies (like web beacons and pixels)</p>
            <p>to gather information when you interact with our Services. Some online tracking</p>
            <p>technologies help us maintain the security of our Services and your account, prevent</p>
            <p>crashes, fix bugs, save your preferences, and assist with basic site functions.</p>
            <p>We also permit third parties and service providers to use online tracking technologies</p>
            <p>on our Services for analytics and advertising, including to help manage and display</p>
            <p>advertisements, to tailor advertisements to your interests, or to send abandoned</p>
            <p>shopping cart reminders (depending on your communication preferences). The third</p>
            <p>parties and service providers use their technology to provide advertising about</p>
            <p>products and services tailored to your interests which may appear either on our</p>
            <p>Services or on other websites.</p>
            <p>To the extent these online tracking technologies are deemed to be a "sale"/"sharing"</p>
            <p>(which includes targeted advertising, as defined under the applicable laws) under</p>
            <p>applicable US state laws, you can opt out of these online tracking technologies by</p>
            <p>submitting a request as described below under section "DO UNITED STATES</p>

            <h3>RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?"</h3>
            <p>Specific information about how we use such technologies and how you can refuse</p>
            <p>certain cookies is set out in our Cookie Notice: htps://consilientlabs.io</p>
            <p>Google Analytics</p>
            <p>We may share your information with Google Analytics to track and analyze the use of</p>
            <p>the Services. The Google Analytics Advertising Features that we may use include:</p>
            <p>Remarketing with Google Analytics, Google Display Network Impressions Reporting</p>
            <p>and Google Analytics Demographics and Interests Reporting. To opt out of being</p>
            <p>tracked by Google Analytics across the Services,</p>
            <p>visit htpss://tools.google.com/dlpage/gaoptout. You can opt out of Google Analytics</p>
            <p>Advertising Features through Ads Settings and Ad Settings for mobile apps. Other</p>
            <p>opt out means include htps://optout.networkadvertising.org/ and</p>
            <p>htps://www.networkadvertising.org/mobile-choice. For more information on the privacy</p>
            <p>practices of Google, please visit the Google Privacy & Terms page.</p>
            
            <h3>6. DO WE OFFER ARTIFICIAL INTELLIGENCE-BASED</h3>
            <h3>PRODUCTS?</h3>
            <p>In Short: We offer products, features, or tools powered by artificial intelligence,</p>
            <p>machine learning, or similar technologies.</p>
            <p>As part of our Services, we offer products, features, or tools powered by artificial</p>
            <p>intelligence, machine learning, or similar technologies (collectively, "AI Products").</p>
            <p>These tools are designed to enhance your experience and provide you with</p>
            <p>innovative solutions. The terms in this privacy notice govern your use of the AI</p>
            <p>Products within our Services.</p>
            <p>Our AI Products</p>
            <p>Our AI Products are designed for the following functions:</p>
            <p>AI applications</p>
            <p>AI automation</p>
            <p>AI deployment</p>
            <p>AI insights</p>
            <p>AI predictive analytics</p>
            <p>AI research</p>
            <p>AI search</p>
            <p>Natural language processing</p>
            <p>Machine learning models</p>
            <p>Text analysis</p>
            <p>IoT</p>
            <p>AI development</p>
            <p>AI bots</p>
            <p>AI document generation</p>
            <p>How We Process Your Data Using AI</p>
            <p>All personal information processed using our AI Products is handled in line with our</p>
            <p>privacy notice and our agreement with third parties. This ensures high security and</p>
            <p>safeguards your personal information throughout the process, giving you peace of</p>
            <p>mind about your data's safety.</p>

            <h3>7. IS YOUR INFORMATION TRANSFERRED</h3>
            <h3>INTERNATIONALLY?</h3>
            <p>In Short: We may transfer, store, and process your information in countries other</p>
            <p>than your own.</p>
            <p>Our servers are located in the United States. If you are accessing our Services from</p>
            <p>outside the United States, please be aware that your information may be transferred</p>
            <p>to, stored, and processed by us in our facilities and by those third parties with whom</p>
            <p>we may share your personal information (see "WHEN AND WITH WHOM DO WE</p>
            <p>SHARE YOUR PERSONAL INFORMATION?" above), in and other countries.</p>
            <p>If you are a resident in the European Economic Area (EEA), United Kingdom (UK), or</p>
            <p>Switzerland, then these countries may not necessarily have data protection laws or</p>
            <p>other similar laws as comprehensive as those in your country. However, we will take</p>
            <p>all necessary measures to protect your personal information in accordance with this</p>
            <p>privacy notice and applicable law.</p>
            <p>European Commission's Standard Contractual Clauses:</p>
            <p>We have implemented measures to protect your personal information, including by</p>
            <p>using the European Commission's Standard Contractual Clauses for transfers of</p>
            <p>personal information between our group companies and between us and our third-</p>
            <p>party providers. These clauses require all recipients to protect all personal</p>
            <p>information that they process originating from the EEA or UK in accordance with</p>
            <p>European data protection laws and regulations. Our Standard Contractual Clauses</p>
            <p>can be provided upon request. We have implemented similar appropriate safeguards</p>
            <p>with our third-party service providers and partners and further details can be provided</p>
            <p>upon request.</p>

            <h3>8. HOW LONG DO WE KEEP YOUR INFORMATION?</h3>
            <p>In Short: We keep your information for as long as necessary to fulfill the purposes</p>
            <p>outlined in this privacy notice unless otherwise required by law.</p>
            <p>We will only keep your personal information for as long as it is necessary for the</p>
            <p>purposes set out in this privacy notice, unless a longer retention period is required or</p>
            <p>permitted by law (such as tax, accounting, or other legal requirements). No purpose</p>
            <p>in this notice will require us keeping your personal information for longer than .</p>
            <p>When we have no ongoing legitimate business need to process your personal</p>
            <p>information, we will either delete or anonymize such information, or, if this is not</p>
            <p>possible (for example, because your personal information has been stored in backup</p>
            <p>archives), then we will securely store your personal information and isolate it from</p>
            <p>any further processing until deletion is possible.</p>
            
            <h3>9. DO WE COLLECT INFORMATION FROM MINORS?</h3>
            <p>In Short: We do not knowingly collect data from or market to children under 18 years</p>
            <p>of age.</p>
            <p>We do not knowingly collect, solicit data from, or market to children under 18 years of</p>
            <p>age, nor do we knowingly sell such personal information. By using the Services, you</p>
            <p>represent that you are at least 18 or that you are the parent or guardian of such a</p>
            <p>minor and consent to such minor dependents use of the Services. If we learn that</p>
            <p>personal information from users less than 18 years of age has been collected, we will</p>
            <p>deactivate the account and take reasonable measures to promptly delete such data</p>
            <p>from our records. If you become aware of any data we may have collected from</p>
            <p>children under age 18, please contact us at dpo@no.no.no.</p>

            <h3>10. WHAT ARE YOUR PRIVACY RIGHTS?</h3>
            <p>In Short: Depending on your state of residence in the US or in some regions, such</p>
            <p>as the European Economic Area (EEA), United Kingdom (UK), Switzerland, and</p>
            <p>Canada, you have rights that allow you greater access to and control over your</p>
            <p>personal information. You may review, change, or terminate your account at any</p>
            <p>time, depending on your country, province, or state of residence.</p>
            <p>In some regions (like the EEA, UK, Switzerland, and Canada), you have certain</p>
            <p>rights under applicable data protection laws. These may include the right (i) to</p>
            <p>request access and obtain a copy of your personal information, (ii) to request rectification</p>
            <p>or erasure; (iii) to restrict the processing of your personal information; (iv)</p>
            <p>if applicable, to data portability; and (v) not to be subject to automated decision-</p>
            <p>making. In certain circumstances, you may also have the right to object to the</p>
            <p>processing of your personal information. You can make such a request by contacting</p>
            <p>us by using the contact details provided in the section "HOW CAN YOU CONTACT</p>
            <p>US ABOUT THIS NOTICE?" below.</p>
            <p>We will consider and act upon any request in accordance with applicable data</p>
            <p>protection laws.</p>
            <p>If you are located in the EEA or UK and you believe we are unlawfully processing</p>
            <p>your personal information, you also have the right to complain to your Member State</p>
            <p>data protection authority or UK data protection authority.</p>
            <p>If you are located in Switzerland, you may contact the Federal Data Protection and</p>
            <p>Information Commissioner.</p>
            <p>Withdrawing your consent: If we are relying on your consent to process your</p>
            <p>personal information, which may be express and/or implied consent depending on</p>
            <p>the applicable law, you have the right to withdraw your consent at any time. You can</p>
            <p>withdraw your consent at any time by contacting us by using the contact details</p>
            <p>provided in the section "HOW CAN YOU CONTACT US ABOUT THIS NOTICE?"</p>
            <p>below or updating your preferences.</p>
            <p>However, please note that this will not affect the lawfulness of the processing before</p>
            <p>its withdrawal nor, when applicable law allows, will it affect the processing of your</p>
            <p>personal information conducted in reliance on lawful processing grounds other than</p>
            <p>consent.</p>
            <p>Opting out of marketing and promotional communications: You can unsubscribe</p>
            <p>from our marketing and promotional communications at any time by clicking on the</p>
            <p>unsubscribe link in the emails that we send, or by contacting us using the details</p>
            <p>provided in the section "HOW CAN YOU CONTACT US ABOUT THIS NOTICE?"</p>
            <p>below. You will then be removed from the marketing lists. However, we may still</p>
            <p>communicate with you for example, to send you service-related messages that are</p>
            <p>necessary for the administration and use of your account, to respond to service</p>
            <p>requests, or for other non-marketing purposes.</p>
            <p>Account Information</p>
            <p>If you would at any time like to review or change the information in your account or</p>
            <p>terminate your account, you can:</p>
            <p>Log in to your account settings and update your user account.</p>
            <p>Upon your request to terminate your account, we will deactivate or delete your</p>
            <p>account and information from our active databases. However, we may retain some</p>
            <p>information in our files to prevent fraud, troubleshoot problems, assist with any</p>
            <p>investigations, enforce our legal terms and/or comply with applicable legal</p>
            <p>requirements.</p>
            <p>UPGRADE Cookies and similar technologies: Most Web browsers are set to accept cookies</p>
            <p>by default. If you prefer, you can usually choose to set your browser to remove</p>
            <p>cookies and to reject cookies. If you choose to remove cookies or reject cookies, this</p>
            <p>could affect certain features or services of our Services. For further information,</p>
            <p>please see our Cookie Notice: htps://www.consilientlabs.io, if any.</p>
            <p>If you have questions or comments about your privacy rights, you may email us at</p>
            <p>contact@consilientlabs.com</p>
            
            <h3>11. CONTROLS FOR DO-NOT-TRACK FEATURES</h3>
            <p>Consent Management</p>
            <p>Most web browsers and some mobile operating systems and mobile applications include a</p>
            <p>Do-Not-Track ("DNT") feature or setting you can activate to signal your</p>
            <p>privacy preference not to have data about your online browsing activities monitored</p>
            <p>and collected. At this stage, no uniform technology standard for recognizing and</p>
            <p>implementing DNT signals has been finalized. As such, we do not currently respond</p>
            <p>to DNT browser signals or any other mechanism that automatically communicates</p>
            <p>your choice not to be tracked online. If a standard for online tracking is adopted that</p>
            <p>we must follow in the future, we will inform you about that practice in a revised</p>
            <p>version of this privacy notice.</p>
            <p>California law requires us to let you know how we respond to web browser DNT</p>
            <p>signals. Because there currently is not an industry or legal standard for recognizing</p>
            <p>or honoring DNT signals, we do not respond to them at this time.</p>
            
            <h3>12. DO UNITED STATES RESIDENTS HAVE SPECIFIC</h3>
            <h3>PRIVACY RIGHTS?</h3>
            <p>In Short: If you are a resident of California, Colorado, Connecticut, Delaware,</p>
            <p>Florida, Indiana, Iowa, Kentucky, Montana, New Hampshire, New Jersey, Oregon,</p>
            <p>Tennessee, Texas, Utah, or Virginia, you may have the right to request access to and</p>
            <p>receive details about the personal information we maintain about you and how we</p>
            <p>have processed it, correct inaccuracies, get a copy of, or delete your personal</p>
            <p>information. You may also have the right to withdraw your consent to our processing</p>
            <p>of your personal information. These rights may be limited in some circumstances by</p>
            <p>applicable law. More information is provided below.</p>
            <p>Categories of Personal Information We Collect</p>
            <p>We have collected the following categories of personal information in the past twelve</p>
            <p>(12) months:</p>
            <p>Category Examples Collected</p>
            <p>A. Identifiers</p>
            <p>Contact details, such as real name, alias,</p>
            <p>postal address, telephone or mobile</p>
            <p>contact number, unique personal identifier,</p>
            <p>online identifier, Internet Protocol address,</p>
            <p>email address, and account name</p>
            <p>YES</p>
            <p>B. Personal information as</p>
            <p>defined in the California</p>
            <p>Customer Records statute</p>
            <p>Name, contact information, education,</p>
            <p>employment, employment history, and</p>
            <p>financial information</p>
            <p>NO</p>
            <p>C. Protected classification</p>
            <p>characteristics under state</p>
            <p>or federal law</p>
            <p>Gender, age, date of birth, race and</p>
            <p>ethnicity, national origin, marital status,</p>
            <p>and other demographic data</p>
            <p>YES</p>
            <p>D. Commercial information Transaction information, purchase history,</p>
            <p>financial details, and payment information</p>
            <p>NO</p>
            <p>E. Biometric information Fingerprints and voiceprints NO</p>
            <p>F. Internet or other similar</p>
            <p>network activity</p>
            <p>Browsing history, search history, online</p>
            <p>behavior, interest data, and interactions</p>
            <p>with our and other websites, applications,</p>
            <p>systems, and advertisements</p>
            <p>NO</p>
            <p>G. Geolocation data Device location YES</p>
            <p>H. Audio, electronic,</p>
            <p>sensory, or similar</p>
            <p>information</p>
            <p>Images and audio, video or call recordings</p>
            <p>created in connection with our business</p>
            <p>activities</p>
            <p>NO</p>
            <p>Business contact details in order to</p>
            <p>htpss://app.termly.io/dashboard/website/28f32d83-38a1-4d4c-bc17-63f4bf0ccbb1/privacy-policy</p>
            <p>I. Professional or</p>
            <p>employment-related</p>
            <p>information</p>
            <p>provide you our Services at a business</p>
            <p>level or job title, work history, and</p>
            <p>professional qualifications if you apply for</p>
            <p>a job with us</p>
            <p>YES</p>
            <p>J. Education Information Student records and directory information NO</p>
            <p>K. Inferences drawn from</p>
            <p>collected personal</p>
            <p>information</p>
            <p>Inferences drawn from any of the collected</p>
            <p>personal information listed above to create</p>
            <p>a profile or summary about, for example,</p>
            <p>an individuals preferences and</p>
            <p>characteristics</p>
            <p>YES</p>
            <p>L. Sensitive personal</p>
            <p>Information</p>
            <p>NO</p>
            <p>We may also collect other personal information outside of these categories through</p>
            <p>instances where you interact with us in person, online, or by phone or mail in the</p>
            <p>context of:</p>
            <p>Receiving help through our customer support channels;</p>
            <p>Participation in customer surveys or contests; and</p>
            <p>Facilitation in the delivery of our Services and to respond to your inquiries.</p>
            <p>We will use and retain the collected personal information as needed to provide the</p>
            <p>Services or for:</p>
            <p>Category A - As long as the user has an account with us</p>
            <p>Category C - As long as the user has an account with us</p>
            <p>Category G - As long as the user has an account with us</p>
            <p>Category I - As long as the user has an account with us</p>
            <p>Category K - As long as the user has an account with us</p>
            <p>Sources of Personal Information</p>
            <p>Learn more about the sources of personal information we collect in "WHAT</p>

            <h3>INFORMATION DO WE COLLECT?"</h3>
            <p>How We Use and Share Personal Information</p>
            <p>Learn about how we use your personal information in the section, "HOW DO WE</p>

            <h3>PROCESS YOUR INFORMATION?"</h3>
            <p>Will your information be shared with anyone else?</p>
            <p>We may disclose your personal information with our service providers pursuant to a</p>
            <p>written contract between us and each service provider. Learn more about how we</p>
            <p>disclose personal information to in the section, "WHEN AND WITH WHOM DO WE</p>

            <h3>SHARE YOUR PERSONAL INFORMATION?"</h3>
            <p>We may use your personal information for our own business purposes, such as for</p>
            <p>undertaking internal research for technological development and demonstration. This</p>
            <p>is not considered to be "selling" of your personal information.</p>
            <p>We have not disclosed, sold, or shared any personal information to third parties for a</p>
            <p>business or commercial purpose in the preceding twelve (12) months. We will not sell</p>
            <p>or share personal information in the future belonging to website visitors, users, and</p>
            <p>other consumers.</p>
            <p>Your Rights</p>
            <p>You have rights under certain US state data protection laws. However, these rights</p>
            <p>are not absolute, and in certain cases, we may decline your request as permitted by</p>
            <p>law. These rights include:</p>
            <p>Right to know whether or not we are processing your personal data</p>
            <p>Right to access your personal data</p>
            <p>Right to correct inaccuracies in your personal data</p>
            <p>Right to request the deletion of your personal data</p>
            <p>Right to obtain a copy of the personal data you previously shared with us</p>
            <p>Right to non-discrimination for exercising your rights</p>
            <p>Right to opt out of the processing of your personal data if it is used for</p>
            <p>targeted advertising (or sharing as defined under Californias privacy law), the</p>
            <p>sale of personal data, or profiling in furtherance of decisions that produce legal</p>
            <p>or similarly significant effects ("profiling")</p>
            <p>Depending upon the state where you live, you may also have the following rights:</p>
            <p>Right to obtain a list of the categories of third parties to which we have</p>
            <p>disclosed personal data (as permitted by applicable law, including California's</p>
            <p>and Delaware's privacy law)</p>
            <p>Right to obtain a list of specific third parties to which we have disclosed</p>
            <p>personal data (as permitted by applicable law, including Oregons privacy law)</p>
            <p>Right to limit use and disclosure of sensitive personal data (as permitted by</p>
            <p>applicable law, including Californias privacy law)</p>
            <p>Right to opt out of the collection of sensitive data and personal data collected</p>
            <p>through the operation of a voice or facial recognition feature (as permitted by</p>
            <p>applicable law, including Floridas privacy law)</p>
            <p>How to Exercise Your Rights</p>
            <p>To exercise these rights, you can contact us by visiting htps://www.consilientlabs.com, by</p>
            <p>emailing us at contact@consilientlabs.com, or by referring to the contact details at the bottom of this</p>
            <p>document.</p>
            <p>We will honor your opt-out preferences if you enact the Global Privacy Control (GPC)</p>
            <p>opt-out signal on your browser.</p>
            <p>Under certain US state data protection laws, you can designate an authorized agent</p>
            <p>to make a request on your behalf. We may deny a request from an authorized agent</p>
            <p>that does not submit proof that they have been validly authorized to act on your</p>
            <p>behalf in accordance with applicable laws.</p>
            <p>Request Verification</p>
            <p>Upon receiving your request, we will need to verify your identity to determine you are</p>
            <p>the same person about whom we have the information in our system. We will only</p>
            <p>use personal information provided in your request to verify your identity or authority</p>
            <p>to make the request. However, if we cannot verify your identity from the information</p>
            <p>already maintained by us, we may request that you provide additional information for</p>
            <p>the purposes of verifying your identity and for security or fraud-prevention purposes.</p>
            <p>If you submit the request through an authorized agent, we may need to collect</p>
            <p>additional information to verify your identity before processing your request and the</p>
            <p>agent will need to provide a written and signed permission from you to submit such</p>
            <p>request on your behalf Appeals</p>
            <p>Under certain US state data protection laws, if we decline to take action regarding</p>
            <p>your request, you may appeal our decision by emailing us at consilientlabs.com. We will</p>
            <p>inform you in writing of any action taken or not taken in response to the appeal,</p>
            <p>including a written explanation of the reasons for the decisions. If your appeal is</p>
            <p>denied, you may submit a complaint to your state attorney general.</p>
            <p>California "Shine The Light" Law</p>
            <p>California Civil Code Section 1798.83, also known as the "Shine The Light" law,</p>
            <p>permits our users who are California residents to request and obtain from us, once a</p>
            <p>year and free of charge, information about categories of personal information (if any)</p>
            <p>we disclosed to third parties for direct marketing purposes and the names and</p>
            <p>addresses of all third parties with which we shared personal information in the</p>
            <p>immediately preceding calendar year. If you are a California resident and would like</p>
            <p>to make such a request, please submit your request in writing to us by using the</p>
            <p>contact details provided in the section "HOW CAN YOU CONTACT US ABOUT THIS</p>
            <h3>NOTICE?"</h3>
            
            <h3>13. DO OTHER REGIONS HAVE SPECIFIC PRIVACY</h3>
            <h3>RIGHTS?</h3>
            <p>In Short: You may have additional rights based on the country you reside in.</p>
            <p>Australia and New Zealand</p>
            <p>We collect and process your personal information under the obligations and</p>
            <p>conditions set by Australia's Privacy Act 1988 and New Zealand's Privacy Act 2020</p>
            <p>(Privacy Act).</p>
            <p>This privacy notice satisfies the notice requirements defined in both Privacy Acts, in</p>
            <p>particular: what personal information we collect from you, from which sources, for</p>
            <p>which purposes, and other recipients of your personal information.</p>
            <p>If you do not wish to provide the personal information necessary to fulfill their</p>
            <p>applicable purpose, it may affect our ability to provide our services, in particular:</p>
            <p>offer you the products or services that you want</p>
            <p>respond to or help with your requests</p>
            <p>manage your account with us</p>
            <p>confirm your identity and protect your account</p>
            <p>At any time, you have the right to request access to or correction of your personal</p>
            <p>information. You can make such a request by contacting us by using the contact</p>
            <p>details provided in the section "HOW CAN YOU REVIEW, UPDATE, OR DELETE</p>

            <h3>THE DATA WE COLLECT FROM YOU?"</h3>
            <p>If you believe we are unlawfully processing your personal information, you have the</p>
            <p>right to submit a complaint about a breach of the Australian Privacy Principles to the</p>
            <p>Office of the Australian Information Commissioner and a breach of New Zealand's</p>
            <p>Privacy Principles to the Office of New Zealand Privacy Commissioner.</p>
            
            <h3>14. DO WE MAKE UPDATES TO THIS NOTICE?</h3>
            <p>In Short: Yes, we will update this notice as necessary to stay compliant with relevant</p>
            <p>laws.</p>
            <p>We may update this privacy notice from time to time. The updated version will be</p>
            <p>indicated by an updated "Revised" date at the top of this privacy notice. If we make</p>
            <p>aterial changes to this privacy notice, we may notify you either by prominently</p>
            <p>posting a notice of such changes or by directly sending you a notification. We</p>
            <p>encourage you to review this privacy notice frequently to be informed of how we are</p>
            <p>protecting your information.</p>
            
            <h3>15. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</h3>
            <p>If you have questions or comments about this notice, you may contact our Data</p>
            <p>Protection Officer (DPO) by email at contact@consilientlabs.com</p>
            <p>If you are a resident in the European Economic Area, we are the "data controller" of</p>
            <p>your personal information. We have appointed No Oh to be our representative in the</p>
            <p>EEA. You can contact them directly regarding our processing of your information, by</p>
            <p>email at contact@consilientlabs.com</p>
            
            <h3>16. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE</h3>
            <h3>DATA WE COLLECT FROM YOU?</h3>
            <p>Based on the applicable laws of your country or state of residence in the US, you</p>
            <p>may have the right to request access to the personal information we collect from you,</p>
            <p>details about how we have processed it, correct inaccuracies, or delete your personal</p>
            <p>information. You may also have the right to withdraw your consent to our processing</p>
            <p>of your personal information. These rights may be limited in some circumstances by</p>
            <p>applicable law. To request to review, update, or delete your personal information,</p>
            <p>please visit: htps://www.consilientlabs.io .</p>

          </div>
        </div>
      </div>
     <style>{`
        .legal-page { 
          padding: 4rem 0; 
          min-height: 80vh; 
        }
        .legal-card { 
          background: var(--card-bg); 
          backdrop-filter: var(--glass-blur);
          border: 1px solid var(--glass-border);
          border-radius: 1.5rem;
          padding: 3rem;
          max-width: 900px;
          margin: 0 auto;
        }
        .header { 
          text-align: center; 
          margin-bottom: 3rem; 
          border-bottom: 1px solid var(--glass-border); 
          padding-bottom: 2rem; 
        }
        .logo { 
          height: 60px; 
          margin-bottom: 1rem; 
        }
        h1 { 
          font-size: 2.5rem; 
          margin-bottom: 0.5rem; 
          background: var(--text-gradient); 
          -webkit-background-clip: text; 
          -webkit-text-fill-color: transparent;
          background-clip: text;
          color: var(--primary-color); 
        }
        .date { 
          color: var(--text-muted); 
          font-size: 0.9rem; 
          text-transform: uppercase; 
          letter-spacing: 1px; 
        }
        .content { 
          font-size: 1.1rem; 
          line-height: 1.8; 
          color: var(--text-main); 
        }
        h3 { 
          color: var(--primary-color); 
          margin-top: 2rem; 
          margin-bottom: 1rem; 
          font-size: 1.3rem; 
        }
        p { 
          margin-bottom: 1rem; 
        }
        .subsection-title {
          font-weight: 600;
        }
        ul { 
          margin: 1rem 0; 
          padding-left: 1.5rem; 
        }
        li { 
          margin-bottom: 0.5rem; 
        }
      `}</style>
    </div>
  );
}